import style from './ConnectBlockSubscribe.module.scss';

export type ConnectBlockEmailType = { html: string };
export const ConnectBlockEmail = ({ html }: ConnectBlockEmailType): JSX.Element => {
  return <div className={style.paragraph} dangerouslySetInnerHTML={{ __html: html }}></div>;
};
